import LTooltip from "@/components/Common/Tooltip/LTooltip.vue";
import Vue from "vue";

Vue.component("LTooltip", LTooltip);
